module.exports.changeLogRecordType = {
    billingAccount: 'billingAccount',
    billingMerchant: 'billingMerchant',
    billingPayoutAccount: 'billingPayoutAccount',
    dashboardMerchant: 'dashboardMerchant',
    paymentMerchant: 'paymentMerchant',
    userAccount: 'userAccount',
    payoutAccount: 'payoutAccount',
    webhookMerchantConfig: 'webhookMerchantConfig',
    webhookConfig: 'webhookConfig',
    webhookMerchantSecret: 'webhookMerchantSecret',
    apmMerchant: 'apmMerchant'
};
